(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.boZokoWidgetGuard = api;
    api.install(root);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function shouldBlockUrl(url) {
    return String(url || '').toLowerCase().indexOf('.zoko.io/') !== -1;
  }

  function install(root) {
    if (!root || !root.Node || !root.Node.prototype || typeof root.addEventListener !== 'function') return false;
    var prototype = root.Node.prototype;
    if (prototype.__boZokoWidgetGuard) return false;
    var nativeInsertBefore = prototype.insertBefore;
    if (typeof nativeInsertBefore !== 'function') return false;

    function guardedInsertBefore(node, referenceNode) {
      if (node && String(node.tagName || '').toUpperCase() === 'SCRIPT' && shouldBlockUrl(node.src)) return node;
      return nativeInsertBefore.call(this, node, referenceNode);
    }

    prototype.__boZokoWidgetGuard = true;
    prototype.insertBefore = guardedInsertBefore;
    root.addEventListener('load', function () {
      root.setTimeout(function () {
        if (prototype.insertBefore === guardedInsertBefore) prototype.insertBefore = nativeInsertBefore;
        try { delete prototype.__boZokoWidgetGuard; } catch (error) { prototype.__boZokoWidgetGuard = false; }
      }, 0);
    }, { once: true });
    return true;
  }

  return { shouldBlockUrl: shouldBlockUrl, install: install };
});
